var components = {
  uniSwipeAction: function() {
    return import(
      /* webpackChunkName: "node-modules/@dcloudio/uni-ui/lib/uni-swipe-action/uni-swipe-action" */ "@dcloudio/uni-ui/lib/uni-swipe-action/uni-swipe-action.vue"
    )
  },
  uniSwipeActionItem: function() {
    return import(
      /* webpackChunkName: "node-modules/@dcloudio/uni-ui/lib/uni-swipe-action-item/uni-swipe-action-item" */ "@dcloudio/uni-ui/lib/uni-swipe-action-item/uni-swipe-action-item.vue"
    )
  }
}
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }